<template>
  <div class="ueditor">
    <vue-ueditor-wrap v-model="content" v-if="allow" :config="myConfig" @ready="ueditorReady">{{ content }}</vue-ueditor-wrap>
  </div>
</template>
<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import { mapGetters , mapMutations } from "vuex";
export default {
  name: "Ueditor",
  components: { VueUeditorWrap },
  mixins: [],
  props: {
    detail: {
      type: String,
      default: "",
    },
    propToolbars:{}
  },
  computed: {
  },
  watch: {
    detail: {
      handler(newVal, oldVal) {
        this.content = newVal;
      },
      immediate: true,
      deep: true,
    },
    content: {
      handler(newVal, oldVal) {
        this.$emit("update:detail", newVal);
        if (!!this.textEditor) {
          this.$emit("update:plainTxt", this.textEditor.getPlainTxt());
        }
      },
      immediate: true,
      deep: true,
    },
    In_the_picture:{
      handler(newVal, oldVal) {
        if(newVal){
          this.ckCatchRemoterImage().then(()=>{
            let articlePicture = []
            let dom = document.createElement("div");
                dom.innerHTML = this.content;
            $.each($(dom).find("img"),function (index,item) {//选择器找到p
              let url = $(this).attr('src');
              let id = $(this).attr('data-resourceid');
              if(id){
                articlePicture.push({url,id:Number(id),categoryId:-1})
              }
            });
            console.log('articlePicture',articlePicture)
            this.SET_ArticlePicture(articlePicture)
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },

  data() {
    return {
      allow: false,
      myConfig: {
        // 如果需要上传功能,找后端小伙伴要服务器接口地址
        // serverUrl: this.$config.baseUrl + 'ueditor/ueditorConfig',
        // serverUrl: 'http://localhost:8090/ueditor/ueditorConfig',
        // 你的UEditor资源存放的路径,相对于打包后的index.html
        UEDITOR_HOME_URL: "/ueditor/",
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 工具栏是否可以浮动
        autoFloatEnabled: false,
        // 初始容器高度
        initialFrameHeight: 100,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 关闭自动保存
        enableAutoSave: true,
				imagePopup: true, //图片操作的浮层开关，默认打开
				videoPopup: true, //视频操作的浮层开关，默认打开
        toolbars: [
          [
            "undo",
            "redo",
            "|",
            "fontsize",
            "forecolor",
            "backcolor",
            "|",
            "bold",
            "italic",
            "underline",
						'fontborder',
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "|",
						'formatmatch',
            "customstyle",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "|",
            "pasteplain",
            "autotypeset",
            "attachment",
						'cleardoc',
						'lineheight',
						'fontfamily',
						'blockquote', 'insertorderedlist', 'insertunorderedlist', 'selectall',  '|',
						'rowspacingtop', 'rowspacingbottom','|',
						'directionalityltr', 'directionalityrtl', 'indent',
          ],
        ],
				//自动排版参数
				autotypeset: {
				    mergeEmptyline: true,           //合并空行
				    removeClass: true,              //去掉冗余的class
				    removeEmptyline: false,         //去掉空行
				    textAlign:"left",               //段落的排版方式，可以是 left,right,center,justify 去掉这个属性表示不执行排版
				    imageBlockLine: 'center',       //图片的浮动方式，独占一行剧中,左右浮动，默认: center,left,right,none 去掉这个属性表示不执行排版
				    pasteFilter: false,             //根据规则过滤没事粘贴进来的内容
				    clearFontSize: false,           //去掉所有的内嵌字号，使用编辑器默认的字号
				    clearFontFamily: false,         //去掉所有的内嵌字体，使用编辑器默认的字体
				    removeEmptyNode: false,         // 去掉空节点
				    //可以去掉的标签
				    removeTagNames: {标签名字:1},
				    indent: false,                  // 行首缩进
				    indentValue : '2em',            //行首缩进的大小
				    bdc2sb: false,
				    tobdc: false
				},

      },
      textEditor: null,
      content: "",
      userEditor: null,
      ueditorContent : '', //编辑器内容
      In_the_picture:false, // 引入图片是否展示文内图片
    };
  },
  methods: {
		...mapMutations("news", ["SET_SetCoverThumbnailContent","SET_TakeManuscriptReplaceTitle","SET_ImportPictureVisible","SET_ArticlePicture"]),

    /* 重设编辑器区域大小 */
    resizeEditor: function() {
      // let h = document.getElementsByClassName("content-box")[0].offsetHeight;
      // let h1 = document.getElementsByClassName("edui-editor-toolbarbox")[0].offsetHeight;
      // let h2 = document.getElementsByClassName("edui-editor-bottomContainer")[0].offsetHeight;
      // h = h - h1 - h2 - 66;
      // this.textEditor.setHeight(h);
      // 编辑器功能区高度

      if(document.getElementsByClassName("edui-editor-toolbarbox")&&document.getElementsByClassName("edui-editor-toolbarbox")[0]){
        let hTop = document.getElementsByClassName("edui-editor-toolbarbox")[0].offsetHeight;
        // 编辑器底部说明区高度
        let hBottom = document.getElementsByClassName("edui-editor-bottomContainer")[0].offsetHeight;
        // 获取页面上编辑器高度
        let ueditorHeight = document.getElementsByClassName("ueditor")[0].offsetHeight;
        let h = ueditorHeight - hTop - hBottom-2;
        this.textEditor.setHeight(h);
      }
    },
    ueditorReady: function(editor) {
			let _self = this;
      this.textEditor = editor;

      this.userEditor = editor;
			editor.addListener( "setThumbnail", function( eventType, path, resourceId ){
					console.log( "开始设为缩略图  " + path + ", " + resourceId );
					let param = {
						id:resourceId,
						path :path,
					}
					_self.SET_SetCoverThumbnailContent(param)

			} );

      this.resizeEditor();
    },
    // 修改视频封面监听点击
    receiveMessage(event){
      if(event.data.status === "Modify_the_cover"){
        console.log('22222222222222',event)
        this.In_the_picture=!this.In_the_picture
        this.In_the_picture_visible = true;
      }
    }
    
  },
  created() {

    window.addEventListener('message',this.receiveMessage,false);

    if(this.propToolbars){
      this.myConfig.toolbars=this.propToolbars
    }
  },
  mounted() {
    const _this = this;
    _this.myConfig.UEDITOR_HOME_URL = getApiHost().webUrl + "/ueditor/";
    _this.allow = true;
    window.onresize = function() {
      _this.resizeEditor();
    };

    console.log('getApiHost().webUrl',getApiHost())
  },
};
</script>
<style lang="scss" scoped>
.ueditor {
  flex: 1;
  overflow: auto;
}

</style>
<style lang="scss">
.percentcheckcontainer {
    height: 100%;
    font-size: 15px;
    display: flex;

    .left {
      border-right: 1px solid #ddd;
      height: 100%;
      & > div {
        padding: 10px 30px;
        text-align: left;
        height: 100%;
        overflow: auto;
      }
      p {
        line-height: 27px;
      }
    }

    .right {
      height: 100%;
      & > div {
        text-align: left;
        padding: 10px 20px 10px 5px;
        button {
          &.btn {
            margin-right: 5px;
            margin-top: 5px;
            padding: 4px;
          }
        }
				.noSelected{
					display: none !important;
				}
      }
      .heimacheckcontent {
        height: calc(100% - 90px);
        padding: 5px 20px 10px 5px;
        max-height: 100%;
        overflow: auto;
        .errortable{
          width: 100%;
          max-width: 100%;
          margin-bottom: 20px;
          border: 1px solid #ddd;
          border-spacing: 0;
          border-collapse: collapse;
          tr{
            height: 50px;
            border-bottom: 1px solid #ddd;
            td{
              padding: 8px;
            }
          }
        }
      }
    }
    .col-xs-7 {
      width: 58.33333333%;
    }
    .col-xs-5 {
      width: 41.66666667%;
    }



    .btn{
      display: inline-block;
      padding: 6px 12px;
      margin-bottom: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.42857143;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      -ms-touch-action: manipulation;
      touch-action: manipulation;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      background-image: none;
      border: 1px solid transparent;
      border-radius: 4px;


      &.btn-xs{
        font-size: 12px;
        line-height: 1.5;
        border-radius: 3px;
        &:hover{
          color: #333;
          background-color: #e6e6e6;
          border-color: #adadad;
        }
      }
      &.btn-default{
        color: #333;
        background-color: #fff;
        border-color: #ccc;
      }
    }

    .btn-primary {
        color: #fff;
        background-color: #337ab7;
        border-color: #2e6da4;
    }

    .mloading-mask{
      display: none;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(155, 155, 155, 0.75);
      filter: progid:DXImageTransform.Microsoft.Alpha(opacity=55);
      position: absolute;

      .mloading-body {
        width: 100%;
        height: 100%;
        position: relative;
      }
      .mloading-bar {
        width: 250px;
        min-height: 22px;
        text-align: center;
        background: #fff;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.27);
        border-radius: 7px;
        padding: 20px 15px;
        font-size: 14px;
        color: #999;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -140px;
        margin-top: -30px;
        word-break: break-all;
        img{
          display: block;
          width: 16px;
          height: 16px;
          margin: auto;
        }
      }
    }
}
.buttonStyle {
  padding:10px 10px;
  cursor: pointer;
}
</style>
